module.exports = __webpack_public_path__ + "img/avatar.02594759.png";